<template>
  <div class="row tbl-visible">
    <div class="col-md-12">
      <TableWrapper
        name="tbl_vehicle"
        :columns="columns"
        :mod-count="modCount"
        :url="url"
        :show-del="deletePermitted"
        :show-add="addPermited"
        :search-form-fields="formFields"
        :offset-height="offsetHeight"
        delete-label="cipherNumber"
        :show-column-visible="true"
        @on-add="showFormModalDialog"
        @on-batch-del="onBatchDelete"
      />
      <VehicleDialog
        :id="entityId"
        :visible="modalForm"
        :width="500"
        :action="url"
        @on-close="onModalClose"
      />
      <VehicleRelationDialog
        :visible="modalRelation"
        caption="车辆绑定用户"
        :width="860"
        :action="relationUrl"
        @on-close="onModalClose"
      />
      <VehicleRefund
        :id="entityId"
        :visible="modalRefund"
        :width="450"
        @on-close="onModalClose"
      />
      <VehiclePhoto
        :id="entityId"
        :visible="modalPhoto"
        :vehicle-number="vehicleNumber"
        :vehicle-photoes="vehiclePhotoes"
        :width="500"
        @on-close="onModalClose"
      />
      <VehicleSuspendDialog
        :id="entityId"
        :visible="modalSuspend"
        :vehicle-number="vehicleNumber"
        :expire-time="vehicleExpireTime"
        :width="500"
        @on-close="onModalClose"
      />
    </div>
  </div>
</template>

<script>
import TableWrapper from '@/components/table-wrapper'
import VehicleDialog from './dialog/vehicle-dialog'
import VehicleRefund from './dialog/vehicle-refund'
import VehicleRelationDialog from './dialog/vehicle-relation'
import VehiclePhoto from './dialog/vehicle-photo'
import VehicleSuspendDialog from './dialog/vehicle-suspend'
import request from '@/utils/request'
import { isBefore } from '@/utils/util'
import { getConfigItem } from '@/apis'
import { isAdmin, hasPermission } from '@/utils/app'
export default {
  name: 'Vehicle',
  components: {
    TableWrapper,
    VehicleDialog,
    VehicleRelationDialog,
    VehicleRefund,
    VehiclePhoto,
    VehicleSuspendDialog
  },
  data() {
    return {
      url: this.$config.apiContextPath + '/vehicle',
      relationUrl: '',
      modalForm: false,
      modalRelation: false,
      modalRefund: false,
      modalPhoto: false,
      modalSuspend: false,
      entityId: 0,
      modCount: 0,
      garages: this.loadGarages(),
      types: [], // this.loadVehicleTypes(),
      vehicleNumber: '',
      vehiclePhotoes: [],
      vehicleExpireTime: '',
      timeout: 30000
    }
  },
  computed: {
    readPermited() { return isAdmin() || hasPermission('PEM_VEHICLE_DATA_READ') },
    addPermited() { return isAdmin() || hasPermission('PEM_VEHICLE_DATA_ADD') },
    deletePermitted() { return isAdmin() || hasPermission('PEM_VEHICLE_DATA_DELETE') },
    updatePermitted() { return isAdmin() || hasPermission('PEM_VEHICLE_DATA_UPDATE') },
    activatePermitted() { return isAdmin() || hasPermission('PEM_VEHICLE_ACTIVATE') },
    syncPermitted() { return isAdmin() || hasPermission('PEM_VEHICLE_DATA_SYNC') },
    relationPermitted() { return isAdmin() || hasPermission('PEM_VEHICLE_RELATION_GET') },
    suspendPermitted() { return isAdmin() || hasPermission('PEM_VEHICLE_SUSPEND') },
    refundPermitted() { return isAdmin() || hasPermission('PEM_VEHICLE_REFUND') },
    offsetHeight() {
      return 290
    },
    formFields() {
      return {
        action: '',
        fields: [
          { label: '创建日期', width: '150px', options: {
            shortcuts: [
              {
                text: '一周',
                value() {
                  const end = new Date()
                  const start = new Date()
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
                  return [start, end]
                }
              },
              {
                text: '一个月',
                value() {
                  const end = new Date()
                  const start = new Date()
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
                  return [start, end]
                }
              },
              {
                text: '三个月',
                value() {
                  const end = new Date()
                  const start = new Date()
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
                  return [start, end]
                }
              }
            ]
          }, placeholder: '请选择创建日期...', type: 'dateranger', hidden: true },
          { label: '绑定车库', placeholder: '请选择绑定车库...', name: 'parkingId', width: '150px', type: 'select', options: this.garages, onChange: this.onParkingChange },
          { label: '车辆类型', placeholder: '请选择车辆类型...', name: 'type', width: '140px', type: 'select', options: this.types },
          { label: '车辆用户', placeholder: '请输入车辆用户...', name: 'member', width: '140px', type: 'input' },
          { label: '车辆编号', placeholder: '请输入车辆编号...', name: 'planetNumber', width: '140px', type: 'input' },
          { label: '车辆押金', placeholder: '请选择押金状态...', name: 'depositPaid', width: '140px', type: 'select', hidden: true, options: [
            { label: '已缴纳', value: 1 },
            { label: '已退费', value: 2 },
            { label: '未缴纳', value: 0 }]
          },
          { label: '车辆标签', placeholder: '请选择车辆标签...', name: 'tag', width: '140px', type: 'select', hidden: true, options: [
            { label: '普通车辆', value: 0 },
            { label: '僵尸车辆', value: 1 }]
          },
          { label: '车主电话', placeholder: '请输入车主电话...', name: 'mobile', width: '140px', type: 'input', hidden: false },
          { label: '车辆状态', placeholder: '请选择车辆状态...', name: 'status', width: '140px', type: 'select', hidden: false, options: [
            { label: '已激活', value: 1 },
            { label: '未激活', value: 0 }]
          },
          { label: '车辆过期', placeholder: '请选择过期状态...', name: 'expireStatus', width: '140px', type: 'select', hidden: true, options: [
            { label: '已过期', value: 1 },
            { label: '未过期', value: 0 }]
          },
          { label: '绑定状态', placeholder: '请选择绑定状态...', name: 'isDeleted', width: '140px', type: 'select', hidden: true, options: [
            { label: '绑定中', value: 0 },
            { label: '已解绑', value: 1 }]
          },
          { label: '运营模式', placeholder: '请选择运营模式...', name: 'businessType', width: '140px', type: 'select', hidden: true, options: this.$config.parkingBusinessType }
        ]
      }
    },
    columns() {
      const _this = this
      return [
        { title: '选择', type: 'selection', width: 60, align: 'center', key: '_selection', disabled: true },
        { title: '车库', align: 'left', key: 'parking', sortable: true, ellipsis: true, tooltip: true, width: 150 },
        { title: '车辆编号', align: 'center', key: 'cipherNumber', sortable: true, ellipsis: true, tooltip: true, width: 110 },
        { title: '标签', align: 'center', key: 'tag', sortable: true, ellipsis: true, tooltip: true, width: 100,
          render: (h, params) => {
            return h('span', {}, (!params.row.tag || params.row.tag === 0) ? '普通车辆' : '僵尸车辆')
          }
        },
        { title: '车主', align: 'left', key: 'owner', sortable: true, ellipsis: true, tooltip: true, width: 100,
          render: (h, params) => {
            return h('span', {}, params.row.owner || '---')
          }
        },
        { title: '电话', align: 'center', key: 'mobile', sortable: true, ellipsis: true, tooltip: true, width: 120,
          render: (h, params) => {
            return h('span', {}, params.row.mobile || '---')
          }
        },
        // { title: '车辆图片', align: 'center', key: 'photo', className: 'avatar', width: 90, hidden: true,
        //   render: (h, params) => {
        //     const photo = params.row.photo
        //     const imageExt = this.$config.imageFileExt
        //     if (photo) {
        //       return h('vue-viewer', {
        //         props: {
        //           thumb: _this.$config.storageHost + '/photo/' + photo + '/' + photo + '_24x24' + imageExt,
        //           full: _this.$config.storageHost + '/photo/' + photo + '/' + photo + imageExt,
        //           listUlClass: 'image-list'
        //         },
        //         style: {
        //           width: '24',
        //           height: '24'
        //         }
        //       }, [

        //       ])
        //     }
        //     return h('span', {}, '---')
        //   }
        // },
        { title: '车辆类型', align: 'left', key: 'typeName', sortable: true, ellipsis: true, tooltip: true, width: 120 },
        // { title: '车主', align: 'center', key: 'owner', sortable: true, width: 100,
        //   render: (h, params) => {
        //     return h('span', {}, params.row.owner || '--')
        //   }
        // },
        { title: '绑定状态', align: 'center', sortable: true, key: 'isDeleted', width: 110, ellipsis: true,
          render: (h, params) => {
            return h('span', {
              style: { color: params.row.isDeleted ? 'red' : 'green' }
            }, params.row.isDeleted ? '已解绑' : '绑定中')
          }
        },
        { title: '楼栋号', align: 'left', key: 'unit', sortable: true, ellipsis: true, tooltip: true, width: 120, hidden: true,
          render: (h, params) => {
            return h('span', {}, params.row.unit ? params.row.unit.split('@').join('-') : '')
          }
        },
        { title: '创建时间', align: 'center', sortable: true, key: 'createTime', ellipsis: true, tooltip: true, width: 120 },
        { title: '有效期限', align: 'center', sortable: true, key: 'expireTime', ellipsis: true, tooltip: true, width: 120,
          render: (h, params) => {
            return h('span', {}, params.row.expireTime || '---')
          }
        },
        { title: '同步时间', align: 'center', key: 'syncTime', sortable: true, ellipsis: true, tooltip: true, width: 120 },
        { title: '押金', align: 'center', sortable: true, key: 'depositPaid', ellipsis: true, tooltip: true, width: 100,
          render: (h, params) => {
            return h('span', {
              style: { color: params.row.depositPaid === 2 ? 'red' : (params.row.status !== 0 || params.row.depositPaid === 1 ? 'green' : 'red') }
            }, params.row.depositPaid === 2 ? '已退费' : (params.row.status !== 0 || params.row.depositPaid === 1 ? '已缴纳' : '未缴纳'))
          }
        },
        { title: '状态', align: 'center', key: 'status', sortable: true, width: 100,
          render: (h, params) => {
            return h('span', {
              style: { color: params.row.status === 0 ? 'red' : (params.row.status === 1 ? 'green' : '#966') }
            }, params.row.status === 0 ? '未激活' : (params.row.status === 1 ? '已激活' : '已报停'))
          }
        },
        {
          title: '原过期时间', align: 'center', key: 'suspendDate', sortable: true, ellipsis: true, tooltip: true, width: 120,
          render: (h, params) => {
            return h('span', {}, params.row.suspendDate || '---')
          }
        },
        { title: '已过期', align: 'center', key: '_expire', sortable: true, width: 100,
          render: (h, params) => {
            return h('span', {
              style: { color: params.row.expireTime && isBefore(params.row.expireTime) ? 'green' : (params.row.expireTime ? 'red' : '#966') }
            }, params.row.expireTime ? (isBefore(params.row.expireTime) ? '未过期' : '已过期') : '---')
          }
        },
        { title: '已退费', align: 'center', key: 'refundStatus', sortable: true, ellipsis: true, tooltip: true, width: 100,
          render: (h, params) => {
            return h('span', {
              style: { color: params.row.refundStatus === 1 ? 'red' : '#966' }
            }, params.row.refundStatus === 1 ? '已退费' : '---')
          }
        },
        { title: '车辆品牌', align: 'center', key: 'vendor', sortable: true, hidden: true, ellipsis: true, tooltip: true, width: 120 },
        { title: '购买时长', align: 'center', key: 'purchaseDuration', sortable: true, hidden: true, ellipsis: true, tooltip: true, width: 120 },
        { title: '电池品牌', align: 'center', key: 'batteryVendor', sortable: true, hidden: true, ellipsis: true, tooltip: true, width: 120 },
        { title: '电池使用时长', align: 'center', key: 'batteryDuration', sortable: true, hidden: true, ellipsis: true, tooltip: true, width: 140 },
        // { title: '绑定用户', align: 'center', width: 105,
        //   render: (h, params) => {
        //     return h('div', [
        //       h('a', {
        //         style: { color: '#126D91', marginRight: '10px' },
        //         on: {
        //           click: () => {
        //             if (params.row.id) {
        //               this.showRelationModalDialog(params.row.id)
        //             }
        //           }
        //         }
        //       }, [
        //         h('i', { class: { 'fas': true, 'fa-eye': true, 'cell-icon-link': true }}),
        //         h('span', {}, '查看')
        //       ])
        //     ])
        //   }
        // },
        { title: '操作', align: 'center', width: 270, disabled: true, key: '_actions', fixed: 'right', hidden: false,
          render: (h, params) => {
            const opList = []
            _this.activatePermitted && opList.push(h('a', {
              style: {
                marginRight: '10px',
                cursor: params.row.status !== 1 && params.row.depositPaid === 1 ? 'pointer' : 'not-allowed',
                color: params.row.status !== 1 && params.row.depositPaid === 1 ? '#126D91' : '#9c9c9c'
                // cursor: params.row.status !== 1 ? 'pointer' : 'not-allowed',
                // color: params.row.status !== 1 ? '#126D91' : '#9c9c9c'
              },
              on: {
                click: () => {
                  if (params.row.id && params.row.status === 0 && params.row.depositPaid === 1) {
                    this.showActivateModalDialog(params.row.id, params.row.cipherNumber)
                  }
                }
              }
            }, [
              h('i', { class: { 'fas': true, 'fa-undo-alt': true, 'cell-icon-link': true }}),
              h('span', {
                domProps: {
                  // title: params.row.status !== 1 && params.row.depositPaid === 1 ? '激活车辆' : (params.row.depositPaid === 1 ? '车辆已激活' : '押金未缴纳')
                  // title: params.row.status !== 1 ? '激活车辆' : '车辆已激活'
                  title: params.row.status === 0 && params.row.depositPaid === 1 ? '激活车辆' : (params.row.depositPaid === 0 ? '押金未缴纳' : '车辆已激活')
                }
              }, '激活')
            ]))
            _this.syncPermitted && opList.push(h('a', {
              style: {
                // color: params.row.syncStatus !== 1 && params.row.status === 1 ? '#126D91' : '#9c9c9c',
                // cursor: params.row.syncStatus !== 1 && params.row.status === 1 ? 'pointer' : 'not-allowed',
                color: '#126D91',
                cursor: 'pointer',
                marginRight: '10px'
              },
              on: {
                click: () => {
                  // if (params.row.id && params.row.syncStatus !== 1 && params.row.status === 1) {
                  this.showSyncModalDialog(params.row.id, params.row.cipherNumber)
                  // }
                }
              }
            }, [
              h('i', { class: { 'fas': true, 'fa-cloud-download-alt': true, 'cell-icon-link': true }}),
              h('span', {
                // domProps: {
                //   title: params.row.syncStatus !== 1 && params.row.status === 1 ? '同步车辆数据至相应车库' : '数据已同步或车辆未激活'
                // }
              }, '同步')
            ]))
            _this.updatePermitted && opList.push(h('a', {
              style: { color: '#126D91', marginRight: '10px' },
              on: {
                click: () => {
                  if (params.row.id) {
                    this.showFormModalDialog(params.row.id)
                  }
                }
              }
            }, [
              h('i', { class: { 'fas': true, 'fa-edit': true, 'cell-icon-link': true }}),
              h('span', {}, '编辑')
            ]))
            const opDropdown = []
            _this.relationPermitted && opDropdown.push(h('DropdownItem', {
              props: { name: 'action_view_user', disabled: !params.row.owner }
            }, [
              h('i', { class: { 'fas': true, 'fa-user': true, 'cell-icon-link': true }}),
              h('span', {}, '查看用户')
            ]))
            _this.readPermited && opDropdown.push(h('DropdownItem', {
              props: { name: 'action_view_photo' }
            }, [
              h('i', { class: { 'fas': true, 'fa-eye': true, 'cell-icon-link': true }}),
              h('span', {}, '查看图片')
            ]))
            _this.suspendPermitted && opDropdown.push(h('DropdownItem', {
              props: { name: 'action_suspend', disabled: params.row.status === 0 }
            }, [
              h('i', { class: { 'fas': true, 'fa-hand-paper': true, 'cell-icon-link': true }}),
              h('span', {
                domProps: {
                  title: params.row.status === 0 ? '车辆尚未激活, 不能进行报停操作' : (params.row.status === 2 ? '启用车辆' : '报停车辆')
                }
              }, params.row.status === 2 ? '启用车辆' : '报停车辆')
            ]))
            _this.deletePermitted && opDropdown.push(h('DropdownItem', {
              props: { name: 'action_delete' }
            }, [
              h('i', { class: { 'fas': true, 'fa-trash': true, 'cell-icon-link': true }}),
              h('span', {}, '删除车辆')
            ]))
            _this.refundPermitted && opDropdown.push(h('DropdownItem', {
              props: { name: 'action_refund', disabled: params.row.status === 0 || params.row.refundStatus === 1 || !(params.row.expireTime && (isBefore(params.row.expireTime))) }
            }, [
              h('i', { class: { 'fas': true, 'fa-undo': true, 'cell-icon-link': true }}),
              h('span', {}, '车辆退款')
            ]))
            opList.push(h('Dropdown', {
              props: { trigger: 'hover', placement: 'bottom' },
              on: {
                'on-click': (name) => {
                  this.onDropdownItemClick(name, params.row)
                }
              }
            }, opDropdown.length > 0 ? [
              h('DropdownItem', { style: { color: '#126D91' }}, [
                h('i', { class: { 'fas': true, 'fa-layer-group': true, 'cell-icon-link': true }}),
                '其他操作',
                h('Icon', { props: { type: 'ios-arrow-down' }})
              ]),
              h('DropdownMenu', { slot: 'list' }, opDropdown)
            ] : []))
            return h('div', opList)
          }
        }
      ]
    }
  },
  methods: {
    async loadVehicleTypes() {
      await request({
        url: this.$config.apiContextPath + '/vehicle/type?fetchAll=true',
        method: 'get'
      }).then(res => {
        this.types = []
        const items = res.data.content
        items.forEach(i => {
          this.types.push({ label: i.name, value: i.id })
        })
      }).catch(error => {
        console.log(error)
        this.types = []
      })
    },
    onParkingChange(parkingId) {
      if (parkingId) {
        request({
          url: this.$config.apiContextPath + '/vehicle/type?parkingId=' + parkingId,
          method: 'get'
        }).then(res => {
          this.types = []
          const items = res.data.content
          items.forEach(i => {
            this.types.push({ label: i.name, value: i.id })
          })
        }).catch(error => {
          console.log(error)
          this.types = []
        })
      }
    },
    async loadGarages() {
      await request({
        url: this.$config.apiContextPath + '/parking/list',
        method: 'get'
      }).then(res => {
        this.garages = []
        const items = res.data
        items.forEach(i => {
          this.garages.push({ label: i.name, value: i.id })
        })
      }).catch(error => {
        console.log(error)
        this.garages = []
      })
    },
    async getVehicleSyncTimeout() {
      const res = await getConfigItem(this.$config.apiContextPath + '/config', 'NS_SYSTEM', 'SYNC_VEHICLE_TIMEOUT')
      if (res.data && res.data.content.length > 0) {
        try {
          const configItem = res.data.content[0]
          this.timeout = parseInt(configItem.value)
        } catch (err) {
          console.log('Invalid timeout')
        }
      }
    },
    onDropdownItemClick(name, item) {
      if (name === 'action_view_user') {
        this.showRelationModalDialog(item.id)
      } else if (name === 'action_view_photo') {
        this.showVehiclePhoto(item.id, item.cipherNumber, [item.photo, item.reversePhoto])
      } else if (name === 'action_suspend') {
        this.showSuspendModalDialog(item.id, item.status, item.cipherNumber, item.expireTime)
      } else if (name === 'action_delete') {
        this.showDelModalDialog(item.id, item.cipherNumber)
      } else if (name === 'action_refund') {
        this.showRefundModalDialog(item.id, item.cipherNumber)
      }
    },
    showVehiclePhoto(id, vehicleNumber, photoes) {
      this.entityId = id ? parseInt(id) : 0
      this.modalPhoto = true
      this.vehicleNumber = vehicleNumber
      this.vehiclePhotoes = photoes
    },
    showRefundModalDialog: function(id, planetNumber) {
      this.entityId = id ? parseInt(id) : 0
      this.modalRefund = true
    },
    showRelationModalDialog: function(id) {
      this.entityId = id ? parseInt(id) : 0
      this.modalRelation = true
      this.relationUrl = this.url + '/' + this.entityId + '/relation'
    },
    showFormModalDialog: function(id = '') {
      this.entityId = id ? parseInt(id) : 0
      this.modalForm = true
    },
    async showSyncModalDialog(id, planetNumber) {
      const _this = this
      this.getVehicleSyncTimeout()
      this.$Modal.confirm({
        title: '确认同步车辆数据么？',
        loading: true,
        render: (h, params) => {
          return h('ul', { style: { padding: '10px 25px 0', fontSize: '9pt' }}, [h('li', {}, planetNumber)])
        },
        onOk: function() {
          const _that = this
          request({
            url: this.$config.apiContextPath + '/sync/vehicle',
            data: [id],
            method: 'POST'
          }).then(res => {
            this.$Notice.success({
              title: '数据同步成功',
              desc: '车辆 `' + planetNumber + '` 数据同步成功!'
            })
            _this.modCount = _this.modCount + 1
            this.$Modal.remove()
          }).catch(error => {
            this.$Notice.error({
              title: '数据同步失败',
              desc: '车辆 `' + planetNumber + '` 数据同步失败, 错误信息: ' + error
            })
            _that.buttonLoading = false
          })
        }
      })
    },
    showActivateModalDialog: function(id, planetNumber) {
      const _this = this
      this.$Modal.confirm({
        title: '确认激活车辆么？',
        loading: true,
        render: (h, params) => {
          return h('ul', { style: { padding: '10px 25px 0' }}, [h('li', {}, planetNumber)])
        },
        onOk: function() {
          const _that = this
          request({
            url: _this.url + '/' + id + '/action/activate',
            method: 'PUT'
          }).then(res => {
            this.$Notice.success({
              title: '激活成功',
              desc: '车辆 `' + planetNumber + '` 激活成功!'
            })
            _this.modCount = _this.modCount + 1
            this.$Modal.remove()
          }).catch(error => {
            this.$Notice.error({
              title: '激活失败',
              desc: '车辆 `' + planetNumber + '` 激活失败, 错误信息: ' + error
            })
            _that.buttonLoading = false
          })
        }
      })
    },
    showSuspendModalDialog: function(id, status, planetNumber, expireTime) {
      if (status === 0) {
        this.$Notice.error({
          title: '车辆尚未激活'
        })
        return
      }
      const _this = this
      const _action = status === 2 ? '启用' : '报停'
      if (status === 2) {
        this.$Modal.confirm({
          title: '确认' + _action + '车辆信息么？',
          loading: true,
          render: (h, params) => {
            return h('ul', { style: { padding: '10px 25px 0' }}, [h('li', {}, planetNumber)])
          },
          onOk: function() {
            const _that = this
            request({
              url: _this.url + '/' + id + '/action/' + (status === 2 ? 'resume' : 'suspend'),
              method: 'PUT'
            }).then(res => {
              this.$Notice.success({
                title: '车辆' + _action + '成功',
                desc: '车辆 `' + planetNumber + '` ' + _action + '成功!'
              })
              _this.modCount = _this.modCount + 1
              this.$Modal.remove()
            }).catch(error => {
              this.$Notice.error({
                title: '车辆' + _action + '失败',
                desc: '车辆 `' + planetNumber + '` ' + _action + '失败, 错误信息: ' + error
              })
              _that.buttonLoading = false
            })
          }
        })
      } else {
        this.entityId = id
        this.modalSuspend = true
        this.vehicleExpireTime = expireTime
        this.vehicleNumber = planetNumber
      }
    },
    showDelModalDialog: function(id, planetNumber) {
      const _this = this
      this.$Modal.confirm({
        title: '确认删除车辆信息么？',
        loading: true,
        render: (h, params) => {
          return h('ul', { style: { padding: '10px 25px 0' }}, [h('li', {}, planetNumber)])
        },
        onOk: function() {
          const _that = this
          request({
            url: _this.url + '/' + id,
            method: 'DELETE'
          }).then(res => {
            this.$Notice.success({
              title: '数据删除成功',
              desc: '车辆 `' + planetNumber + '` 删除成功!'
            })
            _this.modCount = _this.modCount + 1
            this.$Modal.remove()
          }).catch(error => {
            this.$Notice.error({
              title: '数据删除失败',
              desc: '车辆 `' + planetNumber + '` 删除失败, 错误信息: ' + error
            })
            _that.buttonLoading = false
          })
        }
      })
    },
    onModalClose: function(changed) {
      this.entityId = 0
      this.modalForm = false
      this.modalPhoto = false
      this.modalRelation = false
      this.modalRefund = false
      this.modalSuspend = false
      if (changed) {
        this.modCount = this.modCount + 1
      }
    },
    onBatchDelete: function(selections) {
      if (selections.length === 0) {
        this.$Notice.error({
          title: '出错啦',
          desc: '请至少选择一条记录进行删除操作！'
        })
      } else {
        this.$Modal.confirm({
          title: '确定要批量删除车辆信息么？',
          loading: true,
          render: (h, params) => {
            const items = []
            for (const selection of selections) {
              items.push(h('li', { }, selection.planetNumber))
            }
            return h('ul', { style: { padding: '10px 25px 0', fontSize: '9pt' }}, items)
          },
          onOk: function() {
            this.$Modal.remove()
          }
        })
      }
    }
  }
}
</script>

<style lang="less">
  .avatar {
    img {
      width: 24px;
      height: 24px;
      cursor: zoom-in;
      border: 1px solid #c2bfbf;
    }
  }
</style>
